import React, { useState, useEffect } from 'react';
import api from '../api/client';

const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 14, marginBottom: 14, boxSizing: 'border-box', outline: 'none', display: 'block' };
const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnGhost = { padding: '7px 12px', background: 'none', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#555' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const [scripts, setScripts] = useState([]);
  const [kbs, setKbs] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', script_id: '', knowledge_base_id: '', max_history: 20 });

  const load = async () => {
    const [a, s, k] = await Promise.all([api.get('/agents'), api.get('/agents/scripts'), api.get('/agents/knowledge-bases')]);
    setAgents(a.data); setScripts(s.data); setKbs(k.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    const payload = { ...form, script_id: form.script_id ? parseInt(form.script_id) : null, knowledge_base_id: form.knowledge_base_id ? parseInt(form.knowledge_base_id) : null };
    if (editing === 'new') await api.post('/agents', payload);
    else await api.put(`/agents/${editing.id}`, payload);
    setEditing(null); await load();
  };

  const toggle = async (id) => { await api.post(`/agents/${id}/toggle`); await load(); };

  const del = async (id, name) => {
    if (!window.confirm(`Удалить агента «${name}»?`)) return;
    await api.delete(`/agents/${id}`); await load();
  };

  if (editing !== null) return (
    <div style={{ padding: 32, maxWidth: 560 }}>
      <button onClick={() => setEditing(null)} style={btnGhost}>← Назад</button>
      <h2 style={{ fontSize: 18, fontWeight: 600, margin: '16px 0 20px' }}>{editing === 'new' ? 'Новый агент' : `Редактировать: ${editing.name}`}</h2>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#555' }}>Название</label>
      <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} placeholder="Напр. «Поддержка клиентов»" />
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#555' }}>Скрипт</label>
      <select value={form.script_id} onChange={e => setForm(f => ({ ...f, script_id: e.target.value }))} style={inp}>
        <option value="">Без скрипта</option>
        {scripts.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#555' }}>База знаний</label>
      <select value={form.knowledge_base_id} onChange={e => setForm(f => ({ ...f, knowledge_base_id: e.target.value }))} style={inp}>
        <option value="">Без базы знаний</option>
        {kbs.map(k => <option key={k.id} value={k.id}>{k.name}</option>)}
      </select>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 6, color: '#555' }}>Глубина истории</label>
      <input type="number" value={form.max_history} onChange={e => setForm(f => ({ ...f, max_history: parseInt(e.target.value) }))} style={inp} min={1} max={100} />
      <div style={{ display: 'flex', gap: 8 }}><button onClick={save} style={btnPrimary}>Сохранить</button><button onClick={() => setEditing(null)} style={btnGhost}>Отмена</button></div>
    </div>
  );

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Агенты</h1>
        <button onClick={() => { setForm({ name: '', script_id: '', knowledge_base_id: '', max_history: 20 }); setEditing('new'); }} style={btnPrimary}>+ Новый агент</button>
      </div>
      {agents.length === 0 && <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>Агентов нет. Создайте первого.</div>}
      <div style={{ display: 'grid', gap: 10 }}>
        {agents.map(a => {
          const script = scripts.find(s => s.id === a.script_id);
          const kb = kbs.find(k => k.id === a.knowledge_base_id);
          return (
            <div key={a.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontSize: 22 }}>🤖</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{a.name}</div>
                <div style={{ fontSize: 12, color: '#aaa', marginTop: 3, display: 'flex', gap: 8 }}>
                  {script && <span style={{ background: '#f0effe', color: '#534AB7', padding: '2px 8px', borderRadius: 10 }}>📝 {script.name}</span>}
                  {kb && <span style={{ background: '#f0effe', color: '#534AB7', padding: '2px 8px', borderRadius: 10 }}>📚 {kb.name}</span>}
                </div>
              </div>
              <span style={{ fontSize: 12, color: a.is_active ? '#27ae60' : '#aaa' }}>{a.is_active ? '● активен' : '○ выключен'}</span>
              <button onClick={() => { setForm({ name: a.name, script_id: a.script_id || '', knowledge_base_id: a.knowledge_base_id || '', max_history: a.max_history }); setEditing(a); }} style={btnGhost}>Настроить</button>
              <button onClick={() => toggle(a.id)} style={btnGhost}>{a.is_active ? 'Выкл' : 'Вкл'}</button>
              <button onClick={() => del(a.id, a.name)} style={btnDanger}>🗑</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
